export const DATE_FORMAT = 'dd.MM.yyyy';
export const PLANNER_DATE_FORMAT = 'HH:mm dd.MM.yyyy';
